import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-flash-report-view',
  templateUrl: './flash-report-view.component.html',
  styleUrls: ['./flash-report-view.component.css']
})
export class FlashReportViewComponent implements OnInit {
	
	respObject: any;
  downLoadPath=this._rest.FILE_PATH;
  panelName = "Analyst";
  userRole=localStorage.getItem('userRole');
  
  constructor(private router: Router,private route: ActivatedRoute, private _rest: RestapiService) { }

  ngOnInit(): void {
  	if(localStorage.getItem('companyId')=="0"){
  		this.panelName = "Admin";
  	} else {
  		this.panelName = "Analyst";
  	}
  	this.route.params.forEach((params: Params) => {
  		var data = {"fileName":"Flash_"+params['month']+"_"+params['year']+".xlsx","sheetIndex":0};
  		this._rest.getConsoleView(data).subscribe((res) => {
  			this.respObject = res;
  			document.getElementById("bootstrap-data-table").innerHTML=this.respObject.resp;
  		});
     });
  }
 
  backfile(){
  	if(localStorage.getItem('companyId')=="0"){
  		this.router.navigate(['/admin/flashReport']);
  	} else {
      if (this.userRole=="compliance") {
        this.router.navigate(['/compliance/flashReport']);
      }else{
  		  this.router.navigate(['/analyst/flashReport']);
      }
  	}
  	
  }
}


